<footer class="bg-white mt-auto w-full px-10 border-t-black/10 border-t-2">
  <div class="py-5 flex justify-center items-center">
    <img
      src="assets/img/Polizia-di-Stato---logo-2025v2.png"
      alt="Logo Polizia di Stato"
      class="h-8 w-auto"
    />
  </div>
  <div class="flex flex-col text-black">
    <app-menu-mobile [menuItems]="munuLinks" color="black" />
  </div>
  <div class="py-2 list-none font-regular text-sm w-full">
    @for (link of utilsLinks; track $index) {
    <div class="flex flex-col items-center">
      <li class="py-7">{{ link.label }}</li>
    </div>
    <app-divider [isOrizontalDivider]="true" borderColor="border-black/10" width="w-full" />
    }
  </div>
  <div class="flex flex-col items-center py-6 gap-y-8">
    <app-icon iconName="internalMinistryLogo" />
    <!--     <p class="opacity-50 font-regular text-xs">
      &#xA9;2023 - Testata di proprietà del Ministero dell&#39;Interno
    </p> -->
  </div>
</footer>
